import { render, staticRenderFns } from "./phonePreview.vue?vue&type=template&id=78619912&scoped=true"
import script from "./phonePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./phonePreview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./phonePreview.vue?vue&type=style&index=0&id=78619912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78619912",
  null
  
)

export default component.exports